// src/PriceTag.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var PriceTag_default = createIcon({
  displayName: "PriceTag",
  viewBox: "0 0 24 24",
  path: /* @__PURE__ */ jsxs(Fragment, {
    children: [
      /* @__PURE__ */ jsx("rect", {
        opacity: "0",
        width: "24",
        height: "24",
        fill: "white",
        fillOpacity: "0"
      }),
      /* @__PURE__ */ jsx("path", {
        d: "M11.5857 3.586L2.58575 12.586C1.80475 13.367 1.80475 14.633 2.58575 15.414L8.58575 21.414C9.36675 22.195 10.6327 22.195 11.4137 21.414L20.4137 12.414C20.7887 12.039 20.9998 11.53 20.9998 11V5C20.9998 3.895 20.1047 3 18.9998 3H12.9998C12.4698 3 11.9607 3.211 11.5857 3.586ZM17.4998 8C16.6718 8 15.9998 7.328 15.9998 6.5C15.9998 5.672 16.6718 5 17.4998 5C18.3277 5 18.9998 5.672 18.9998 6.5C18.9998 7.328 18.3277 8 17.4998 8Z",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "currentColor"
      })
    ]
  })
});

export {
  PriceTag_default
};
